// extracted by mini-css-extract-plugin
export var animationContainer = "_o3-0";
export var footer = "_o3-1";
export var gray = "_o3-2";
export var lineItem = "_o3-3";
export var lineItemImage = "_o3-4";
export var lineItemInfo = "_o3-5";
export var lineItemText = "_o3-6";
export var lineItems = "_o3-7";
export var modalContent = "_o3-8";
export var options = "_o3-9";
export var orderName = "_o3-a";
export var refundAmount = "_o3-b";